import React, { useMemo } from 'react';
import cx from 'classnames';
import { scaleColorTraffic } from 'js/utils/color';
import { orgTreeNodeIconProps, orgTreeNodeKindLabel } from 'js/utils/org-utils';
import OrgTreeNodeTypeIcon from 'js/routes/Organizations/components/ManageOrg/OrgTreeVeiw/OrgTreeNodeTypeIcon';

const ScorecardNode = ({ parentKey = '', node, columnData }) => {
  const {
    depth,
    data: { type, name, scores, isRoot = false },
    children,
  } = node;

  const kindLabel = useMemo(
    () => orgTreeNodeKindLabel({ type, isRoot, depth }),
    [type, isRoot, depth]
  );

  const iconNode = useMemo(
    () => orgTreeNodeIconProps({ type, isRoot }),
    [type, isRoot]
  );

  const paletteTierClass = useMemo(
    () => `palette-tiers-${type === 'team' ? 0 : 1 + (depth % 7)}`,
    [type, depth]
  );

  const rowClasses = useMemo(
    () =>
      cx('muted-white-bg', paletteTierClass, {
        'squad-scorecard-team': type === 'team',
        'squad-scorecard-group': type !== 'team',
      }),
    [paletteTierClass, type]
  );

  const nameClasses = useMemo(
    () => cx('squad-scorecard-name', 'muted-white-bg', paletteTierClass),
    [paletteTierClass]
  );

  return (
    <>
      <div className={rowClasses}>
        <div className="squad-scorecard-name-wrapper">
          <div className={nameClasses}>
            <div
              className="squad-scorecard-name-content"
              style={{ paddingLeft: `${depth * 10}px` }}
            >
              <div>{name}</div>
              <div className="details">
                <OrgTreeNodeTypeIcon node={iconNode} className="icon-left" />
                {kindLabel}
              </div>
            </div>
          </div>
        </div>
        {columnData.map(({ combinedKey, columnType }) => {
          const score = scores[combinedKey];
          const isQuestionSet = columnType === 'questionSet';
          return (
            <div
              className={cx({
                'squad-scorecard-question': !isQuestionSet,
                'squad-scorecard-question-set': isQuestionSet,
              })}
              key={combinedKey}
            >
              <div
                className="squad-scorecard-result"
                style={{ backgroundColor: scaleColorTraffic(score?.score) }}
              />
            </div>
          );
        })}
      </div>

      {children?.map((c, i) => {
        const key = `scorecard-${parentKey}-${i}`;

        return (
          <ScorecardNode
            key={key}
            parentKey={key}
            node={c}
            columnData={columnData}
          />
        );
      })}
    </>
  );
};

export default ScorecardNode;
